import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useLocalizeMessage, useDateTimeFormat } from 'libs.nucleus';
import { ListInformation, useCountriesOptions } from 'libs.react';
import { useWorkspaceIdpOptions, useRoleTranslations } from '../../features';
export const UserDetailsSection = ({ entityId, user }) => {
    const translate = useLocalizeMessage();
    const roleTranslations = useRoleTranslations();
    const { formatDateTime: formatCreatedAt } = useDateTimeFormat();
    const allCountries = useCountriesOptions();
    const { idpOptions, showIdpSelect } = useWorkspaceIdpOptions();
    const listItems = useMemo(() => {
        const entityAccess = user.entitiesAccess.find((group) => group.entityId === entityId);
        const roles = entityAccess?.roleGroups.map((role) => roleTranslations[role]);
        const country = allCountries.find((c) => c.value === user.countryCode)?.label || user.countryCode;
        const idpNames = idpOptions
            .filter((idp) => entityAccess?.registeredIdps?.includes(idp.value))
            .map((idp) => idp.label);
        return [
            { title: translate('First name'), dataTestId: 'profile-first-name', description: user.first },
            { title: translate('Last name'), dataTestId: 'profile-last-name', description: user.last },
            { title: translate('Roles'), dataTestId: 'profile-roles', description: roles },
            { title: translate('Email'), dataTestId: 'profile-email', description: user.email },
            { title: translate('Country of residence'), dataTestId: 'profile-country', description: country },
            ...(showIdpSelect
                ? [
                    {
                        title: translate('Identity providers'),
                        dataTestId: 'profile-idps',
                        description: idpNames.length > 0 ? idpNames : '',
                    },
                ]
                : []),
            { title: translate('Created'), dataTestId: 'profile-email', description: formatCreatedAt(user.createdAt) },
        ];
    }, [user, idpOptions]);
    return _jsx(ListInformation, { items: listItems });
};
